import { Box, Checkbox, TableCell, TableRow, Tooltip } from "@mui/material";
import { Restore as RestoreIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon, } from "@mui/icons-material";
import moment from "moment";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { PermissionWrapper } from "../../../../wrappers";
import { trackActivity } from "../../../../utils/mixpanel";
import UploadingIcon from "../../../../shared_elements/components/UploadingIcon";
import { dateMonthYearDateFormat } from "../../../../constants";
import { ActionPerformed } from "../../../../shared_elements/components";
import AuditPopover from "../../../../shared_elements/components/popover";
import { useState } from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';

const MouList = ({ item, bulk, onEditFn, viewRevisonHistory, onView, onDeleteEolFn, toggleBulkOps, onOpenAttachments, uploadedFileData, uploadFileProgressData, viewFileStatus, slug }) => {

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `MOU Listing`, page_type: page_type, })
  }
  return (
    <TableRow >
      <TableCell className="table-actions-list">
        <Box className="table-icon-container">
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "mou_list", operationType: ['D'] }}>
            <Checkbox style={{ verticalAlign: 'super' }} color="primary" size='small' checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} onChange={toggleBulkOps} />
          </PermissionWrapper>
          <AuditPopover item={item}>
            <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
          </AuditPopover>
          <Tooltip title="Revision History"><RestoreIcon className="revision-history" sx={{ cursor: 'pointer' }} onClick={() => { handleItemClicked('RevisionHistoryIcon'); viewRevisonHistory(); }} fontSize='small' color='primary' /></Tooltip>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "mou_list", operationType: ['R'] }}>
            <Tooltip title="View"><VisibilityIcon sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('ViewIcon') }} fontSize='small' color='primary' /></Tooltip>
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "mou_list", operationType: ['U'] }}>
            <Tooltip title="Edit"><EditIcon sx={{ cursor: 'pointer' }} onClick={() => { onEditFn(); handleItemClicked('EditIcon') }} fontSize='small' color='primary' /></Tooltip>
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "mou_list", operationType: ['D'] }}>
            <Tooltip title="Delete"><DeleteIcon sx={{ cursor: 'pointer' }} onClick={() => { onDeleteEolFn(); handleItemClicked('DeleteIcon') }} fontSize='small' color='error' /></Tooltip>
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "mou_list", operationType: ['R'] }}>
          {
            item?.attachments?.length > 0 && (
              <Tooltip title="Attached File(s)">
                <Box className="attachment-container">
                    <AttachFileIcon fontSize="small" color="primary" onClick={() => { onOpenAttachments(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                  <Box className="attachment-count"> ({item.attachments.length}) </Box>
                </Box>
              </Tooltip>
            )
          }
          </PermissionWrapper>
          { (slug === item?.slug  ) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
        </Box>
      </TableCell>
      <TableCell sx={{ whiteSpace: "nowrap", cursor: 'pointer' }} onClick={() => {onView(); handleItemClicked();}}>{item?.mou_date ? moment(item.mou_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
      <TableCell sx={{ whiteSpace: "nowrap", cursor: 'pointer' }} onClick={() => {onView(); handleItemClicked();}}>{item?.lessee?.name || "--"}</TableCell>
      <TableCell sx={{ whiteSpace: "nowrap", cursor: 'pointer' }} onClick={() => {onView(); handleItemClicked();}}>{item?.lessor?.name || "--"}</TableCell>
      <TableCell sx={{ whiteSpace: "nowrap", cursor: 'pointer' }} onClick={() => {onView(); handleItemClicked();}}>{item?.managed || "--"}</TableCell>
      <TableCell sx={{ whiteSpace: "nowrap", cursor: 'pointer' }} onClick={() => {onView(); handleItemClicked();}}>{item?.tied_asset || "--"}</TableCell>
    </TableRow>
  );
};

export default MouList;
